

import { computed, ref, reactive, toRefs } from '@vue/composition-api'
import shadeColor from './@core/utils/shadeColor';
import api from './api';
import { initLang } from './plugins/i18n';


const state = reactive({
    appInitialized: false,
    user: {},
    userIsAdmin: false,
    tenant: {},
    token: ''
});

const isRestoring = ref(false);

export default function useAuth() {

    if (localStorage.getItem('token')) {
        state.token = localStorage.getItem('token');
    }

    const tryRestore = async () => {
        if (!isRestoring.value) {
            isRestoring.value = true;
            if (!state.appInitialized) {
                await initLang();
                const persistedToken = localStorage.getItem('token');
                if (persistedToken) {
                    const dateTimeString = localStorage.getItem("token_expires");

                    const expires = new Date(dateTimeString);
                    if (expires > new Date()) {

                        const userResponse = await api.getUserProfile();
                        const tenantResponse = await api.getTenant();

                        if (userResponse.ok && tenantResponse.ok) {
                            setUser(userResponse.data);
                            setTenant(tenantResponse.data);
                            state.token = persistedToken;
                            state.appInitialized = true;
                            return;
                        }
                        else if (userResponse.status == 401) {
                            logoutUser();
                        }
                    }
                    else {
                        logoutUser();
                    }
                }

                state.appInitialized = true;
            }
        }
    }


    const setTheme = (primaryColorHex, gradientColorHex) => {
        document.documentElement.style.setProperty('--v-primary-base', primaryColorHex);
        document.documentElement.style.setProperty('--v-gradient-base', gradientColorHex);
    }

    const isAuthenticated = computed(() => {
        return state.token != '';
    });

    const setToken = async (token, expires) => {
        localStorage.setItem('token', token);
        localStorage.setItem('token_expires', expires);
        state.token = token;
    }

    const persistTenants = async (tokens) => {
        localStorage.setItem('tenants', JSON.stringify(tokens));
    }

    const getUserTenants = () => {
        if (localStorage.getItem('tenants') == null) return [];

        return JSON.parse(localStorage.getItem('tenants'));
    }

    const setUser = async (user) => {
        state.user = user;
        state.userIsAdmin = user.is_tenant_admin || user.admin_groups.length > 0;
    }

    const setTenant = async (tenant) => {
        state.tenant = tenant;
        if (tenant.color) {
            const color = tenant.color.startsWith('#') ? tenant.color : `#${tenant.color}`;
            const gradient = shadeColor(color, 25);
            setTheme(color, gradient);
        }
    }

    const logoutUser = async (token) => {

        try {
            await api.logout();
        }
        catch (e) { }

        localStorage.removeItem('tenants');
        localStorage.removeItem('token');
        localStorage.removeItem('token_expires');

        state.user = {};
        state.tenant = null;
        state.token = '';
        state.userIsAdmin = false;

        window.location.href = '/login';
    }


    return {
        isAuthenticated,
        setToken,
        setUser,
        setTenant,
        logoutUser,
        tryRestore,
        persistTenants,
        getUserTenants,
        ...toRefs(state),
    }
}
